var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAirport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#BCBEC0",
    stroke: "#BCBEC0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6866 12.0754C19.2067 12.0379 21 11.7134 21 10.9987C21 10.2853 19.2067 9.96345 17.6866 9.92466C16.1691 9.88715 15.0987 9.92466 15.0987 9.92466L7.51415 1L6.31635 1L10.2386 8.65022C10.7321 9.60151 8.95198 9.76952 8.95198 9.76952L4.25642 10.3305C4.14102 10.2297 2.36227 7.9652 2.36227 7.9652H1L2.48828 10.6265C1.80515 10.779 1.48945 10.8759 1.48945 10.9987C1.48945 11.124 1.80517 11.2197 2.48828 11.3709L1 14.0348H2.36227C2.36227 14.0348 4.14102 11.7703 4.25642 11.6682L8.95198 12.2278C8.95198 12.2278 10.7321 12.3985 10.2386 13.3497L6.31635 21H7.51415L15.0987 12.0754C15.0987 12.0754 16.1691 12.1128 17.6866 12.0754Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAirport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Airport.c025eb099318f06088352edfc952d6e3.svg";